const isFlagSet = (v) => v === true || v === "true"

export const attachmentPrice = (attachment, vehicle) => {
    const base = parseInt(attachment?.Price) || 0
    if (isFlagSet(attachment?.PriceSizeMult)) {
        return base * Math.max(1, parseInt(vehicle?.Silhouette) || 1)
    }
    return base
}

export const priceLabel = (attachment, vehicle) => {
    const price = attachmentPrice(attachment, vehicle)
    return isFlagSet(attachment?.PriceSizeMult) ? `${price} (${attachment.Price || 0} × Silhouette)` : `${price}`
}
